module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_03-c76545547452bc815a5aa410a1fe5f8c.jpg";